import React, { Fragment } from 'react';

import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 

import GhaPoAwbsPaymentUnit from '../../../../models/GhaPoAwbsPaymentUnit';
import GhaPoAwbsPayments from '../../../../models/GhaPoAwbsPayments';

import { getAdditionalServiceName } from '../../../../utils/additionalServices';
import { formatCurrency } from '../../../../utils/currencyFormatter';

import paymentsTableStyles from './payments.module.css';
import commonStyles from '../../../common/common.module.css';

interface PaymentsTableProps {
  payments: GhaPoAwbsPayments;
};

const PADDING_RIGHT_CELLS = '5px';
const PADDING_LEFT_CELLS = '5px';
const headerStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };

const paymentsTable = (props: PaymentsTableProps) => {

  return (
    <Fragment>
      <MaterialTable

        components={{Container: props => <Paper {...props} elevation={0} className={`${ commonStyles.paperTable } ${ paymentsTableStyles.paymentsTable }`}/>}}

        data = { props.payments.payments }

        columns = {[
          { title: 'Fee',
            render: (rowData: GhaPoAwbsPaymentUnit) => {
              
              return ( 
                <div>{ getAdditionalServiceName(rowData.service) } 
                { rowData.service === 'other' || rowData.service === 'gha_adjust' ? ' ' + rowData.reason : ''}
                </div>
              )
              
            }, cellStyle: {paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS, width: '120px', textAlign: 'left' }, headerStyle
          },
          { title: 'Due', field: 'due', type: 'currency' ,headerStyle: { textAlign: 'right' }, cellStyle: { width: '80px', textAlign: 'right' } },
          { title: 'Pending', field: 'pending', type: 'currency', headerStyle: { textAlign: 'right' }, cellStyle: { width: '80px', textAlign: 'right' } },
          { title: 'Paid', field: 'paid', type: 'currency' , headerStyle: { textAlign: 'right' }, cellStyle: { width: '80px', textAlign: 'right' } }
        ]}
          
        options = {{
          paging: false,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          showTitle: false,
          toolbar: false,
          sorting: false
        }}
      /> 
      <div className={ paymentsTableStyles.totalWrapper }>
          <span className={ paymentsTableStyles.totalTextAwb }>Total for AWB:</span>
          <span className={ paymentsTableStyles.totalText }>{ formatCurrency(props.payments.totalDue, 2, '$') }</span> 
          <span className={ paymentsTableStyles.totalText }>{ formatCurrency(props.payments.totalPending, 2, '$') }</span> 
          <span className={ paymentsTableStyles.totalText }>{ formatCurrency(props.payments.totalPaid, 2, '$') }</span> 
      </div>
      <div className={ paymentsTableStyles.totalAlignDiv }></div>
    </Fragment> 
  )
}

export default paymentsTable;